import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=3d0c9b44&scoped=true"
import script from "./thankyou.vue?vue&type=script&lang=js"
export * from "./thankyou.vue?vue&type=script&lang=js"
import style0 from "./thankyou.vue?vue&type=style&index=0&id=3d0c9b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c9b44",
  null
  
)

export default component.exports